export default "__VITE_ASSET__CiWuQAem__"